var _path, _path2, _rect, _rect2, _path3, _path4, _path5, _path6, _polygon, _rect3, _rect4, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _polygon2, _polygon3, _polygon4, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 66 66",
    viewBox: "0 0 66 66",
    id: "cyber-crime",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#475D6B",
    d: "M57.2,14.1H12.1c-0.9,0-1.6,0.7-1.6,1.6v31.5c0,0.9,0.7,1.6,1.6,1.6h45.1c0.9,0,1.6-0.7,1.6-1.6V15.7 C58.8,14.8,58.1,14.1,57.2,14.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3C4D56",
    d: "M57.2,14.1H34.6v34.7h22.6c0.9,0,1.6-0.7,1.6-1.6V15.7C58.8,14.8,58.1,14.1,57.2,14.1z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40.6,
    height: 26.2,
    x: 14.4,
    y: 18.4,
    fill: "#8AC6C3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 20.3,
    height: 26.2,
    x: 14.4,
    y: 18.4,
    fill: "#9BD7D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7E7E9",
    d: "M57.6,48.8H11.7c-0.6,0-1.3,0.4-1.6,0.9L4.5,62.9c-0.3,0.8,0,1.5,0.9,1.5H64c0.8,0,1.2-0.7,0.9-1.5 l-5.7-13.2C59,49.2,58.3,48.8,57.6,48.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D5D9DC",
    d: "M34.7,48.8h-23c-0.6,0-1.3,0.4-1.6,0.9L4.5,62.9c-0.3,0.8,0,1.5,0.9,1.5h29.4V48.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7E7E9",
    d: "M56 51.1h-42c-.3 0-.6.2-.7.4l-1.3 3.5c-.1.3.1.5.4.5h45.2c.3 0 .5-.2.4-.5l-1.3-3.5C56.6 51.3 56.3 51.1 56 51.1zM42.6 57.3h-15c-.3 0-.6.2-.7.5l-.4 3.3c0 .3.2.6.6.6h16.1c.4 0 .6-.3.6-.6l-.4-3.3C43.2 57.6 42.9 57.3 42.6 57.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#D5D9DC",
    d: "M58 55.1l-1.3-3.5c-.1-.2-.4-.4-.7-.4H34.6v4.5h23C58 55.6 58.1 55.4 58 55.1zM43.3 57.9c0-.3-.3-.5-.7-.5h-8v4.4h8.5c.4 0 .6-.3.6-.6L43.3 57.9z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#E1B724",
    points: "30 33.5 1 33.5 1 15.2 15.7 2.3 30 15.2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 22.2,
    height: 24.9,
    x: 4.4,
    y: 1.6,
    fill: "#E9674A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 11.3,
    height: 24.9,
    x: 4.4,
    y: 1.6,
    fill: "#DA5339"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M18.8,5.1c-1.3-1.7-3.1-1.4-3.1-1.4l0,10.4c1,0,1.4-0.2,1.6-0.4c0.1-0.1,0.4-0.3,0.6-0.5 c0.2-0.1,0.3-0.3,0.3-0.5c0-1.1,0.4-1.9,0.4-1.9c0.9-0.6,0.4-1.3,0.4-1.3S20.1,6.8,18.8,5.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7E7E9",
    d: "M12.6,5.1c-1.3,1.7-0.3,4.4-0.3,4.4s-0.4,0.7,0.4,1.3c0,0,0.3,0.8,0.4,1.9c0,0.2,0.1,0.4,0.3,0.5 c0.2,0.2,0.5,0.4,0.6,0.5c0.2,0.2,0.7,0.3,1.7,0.4V3.7C15.7,3.7,13.9,3.4,12.6,5.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#475D6B",
    d: "M18.4 8.5c-.1-.1-.5-.6-1.3-.5-.5 0-.6.5-.6.8 0 .2.1.4.3.5 1.1.6 1 .4 1.3.3C18.4 9.4 18.5 8.6 18.4 8.5zM17.8 10.8c0 0-.3.1-.5.3-.2.2 0 .4 0 .4.1.1-.1.7-.1.7C17.9 11.9 17.8 10.8 17.8 10.8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#3C4D56",
    d: "M15.7,9c0,0,0.7,0.4,0.6,1.1c-0.1,0.7-0.4,0.7-0.6,0.7V9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#475D6B",
    d: "M13.1 8.5c.1-.1.5-.6 1.3-.5.5 0 .6.5.6.8 0 .2-.1.4-.3.5-1.1.6-1 .4-1.3.3C13.1 9.4 13 8.6 13.1 8.5zM13.6 10.8c0 0 .3.1.5.3.2.2 0 .4 0 .4-.1.1.1.7.1.7C13.5 11.9 13.6 10.8 13.6 10.8zM15.7 9c0 0-.7.4-.6 1.1s.4.7.6.7V9z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#D5D9DC",
    d: "M12.8,19.3l6.2-3.6c0.4-0.2,0.8-0.2,1.2-0.1c0.3,0.1,0.6,0,0.9-0.1c0.5-0.3,0.8-0.9,0.5-1.3 c0-0.1-0.1-0.1-0.2-0.2c-0.2-0.2-0.4-0.5-0.4-0.8c0-0.1,0-0.2-0.1-0.2c-0.2-0.4-0.9-0.5-1.4-0.2c-0.3,0.2-0.5,0.4-0.6,0.7 c-0.1,0.4-0.4,0.8-0.7,1L12,18c-0.4,0.2-0.8,0.2-1.2,0.1c-0.3-0.1-0.6,0-0.9,0.1c-0.5,0.3-0.8,0.9-0.5,1.3 c0,0.1,0.1,0.1,0.2,0.2c0.2,0.2,0.4,0.5,0.5,0.8c0,0.1,0,0.2,0.1,0.2c0.2,0.4,0.9,0.5,1.4,0.2c0.3-0.2,0.5-0.4,0.6-0.7 C12.1,19.9,12.4,19.5,12.8,19.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7E7E9",
    d: "M18.3,19.3L12,15.7c-0.4-0.2-0.8-0.2-1.2-0.1c-0.3,0.1-0.6,0-0.9-0.1c-0.5-0.3-0.8-0.9-0.5-1.3 c0-0.1,0.1-0.1,0.2-0.2c0.2-0.2,0.4-0.5,0.4-0.8c0-0.1,0-0.2,0.1-0.2c0.2-0.4,0.9-0.5,1.4-0.2c0.3,0.2,0.5,0.4,0.6,0.7 c0.1,0.4,0.4,0.8,0.7,1L19,18c0.4,0.2,0.8,0.2,1.2,0.1c0.3-0.1,0.6,0,0.9,0.1c0.5,0.3,0.8,0.9,0.5,1.3c0,0.1-0.1,0.1-0.2,0.2 c-0.2,0.2-0.4,0.5-0.5,0.8c0,0.1,0,0.2-0.1,0.2c-0.2,0.4-0.9,0.5-1.4,0.2c-0.3-0.2-0.5-0.4-0.6-0.7 C18.9,19.9,18.6,19.5,18.3,19.3z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FBD32D",
    points: "15.7 24.3 30 33.5 30 15.2"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FBD32D",
    points: "15.7 24.3 1 33.5 1 15.2"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#E1B724",
    points: "1 33.5 15.7 22 30 33.5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 4.5,
    height: 7,
    x: 36.1,
    y: 28.9,
    fill: "#FFF",
    transform: "rotate(-45.001 38.342 32.371)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.2,
    height: 7,
    x: 36.4,
    y: 29.7,
    fill: "#E7E7E9",
    transform: "rotate(-45.001 37.55 33.163)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "32.2 26.2 33 33.8 39.8 27"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E7E7E9",
    points: "32.2 26.2 36.4 30.4 39.8 27"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrime);
export default __webpack_public_path__ + "static/media/crime.fc1c0e2ae6cab08edd747acbaeb98ce4.svg";
export { ForwardRef as ReactComponent };